import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AtbHomeService } from '../../../services/atbHome.service';
import { environment } from '../../../../environments/environment.prod';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgForm } from '@angular/forms';


declare var jQuery: any;
@Component({
  selector: 'app-hoteliers-structures-rooms',
  templateUrl: './hoteliers-structures-rooms.component.html',
  styleUrls: ['../../../app.component.css']
})
export class HoteliersStructuresRoomsComponent implements OnInit {
  queryStr;
  idStructure;
  data: any[] = new Array();
  dataManage;
  errorMessage;
  permitsBasePath;
  path;
  visibleEdit;
  @ViewChild('roomForm') formRoom: NgForm;
  constructor(private spinner: NgxSpinnerService, private router: Router, private atbService: AtbHomeService) { }




  ngOnInit() {
    this.permitsBasePath = "permessituristici";
    this.path = "camere";
    this.idStructure = localStorage.getItem("idStructure")
    this.queryStr = this.path +"/" + this.idStructure;
    this.visibleEdit = false;
    this.RoomListFunction()
  }

  open() {
    jQuery('#sidebar').toggleClass('active');

  console.log('press')
  }


  selectRow(d) {
    this.dataManage = d
    this.visibleEdit = true;
  }


  editRoom() {
    var id = this.dataManage['id'];
    var idStruttura = this.dataManage['idStruttura']
    this.dataManage = this.formRoom.value
    this.dataManage['idStruttura'] = idStruttura
    this.dataManage['id'] =   id



    console.log(this.dataManage)

    this.spinner.show()
    this.atbService.edit(this.dataManage, this.permitsBasePath + '/' + this.path).subscribe(
      response => {
        if (response.outcome.success === true) {
          // this.router.navigate(['/hoteliers/structure/structures']);
        this.spinner.hide()
        this.RoomListFunction()
        this.visibleEdit = false;
        } else {
          this.errorMessage =
            response.outcome.code + response.outcome.description;
         // swal2('Attenzione', this.errorMessage, 'warning');
         this.RoomListFunction()
         this.spinner.hide()
        }
      },
      error => {
        // this.logger.log("Error", error, 200);
        this.errorMessage = 'Spiacente, si è verificato un errore tecnico.';
        this.spinner.hide()
      }
    );
  }
  closeRoom() {
    this.visibleEdit = false;
  }

  closeRoomDetails() {
    this.router.navigate(['/hoteliers/structure/structures']);
  }

  RoomListFunction() {
    this.spinner.show();


    this.atbService.getListFilter(this.permitsBasePath + '/' + this.queryStr).subscribe(
      (response) => {
      // Verificare outcome
      if (response.outcome.success === true) {
        this.data = response.results
        this.dataManage = this.data[0];

        this.spinner.hide()



      console.log('Test', this.data);
       } else {
      this.spinner.hide()
    }

      },
      (error) => {
        console.log('Error ', error);
       // this.goToAtbAtHome();
       this.spinner.hide()

      }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/views/hoteliers-permits/hoteliers-structures-rooms/hoteliers-structures-rooms.component.ts